<div class="d-flex flex-row baner" [@stretchDown]="currentlySelected > 0 ? 'open' : 'close'">
  <button class="baner-button" (click)="delete()">
    <img src="./assets/ui/svg/white/trash-icon.svg" class="smaller">
    <span>Delete</span>
  </button>
  <button class="baner-button" (click)="selectAll()" *ngIf="!isAllSelected">
    <img src="./assets/ui/svg/white/select_all.svg">
    <span>Select all</span>
  </button>
  <div class="flex-grow-1"></div>
  <div class="d-flex flex-row align-items-center selected">
    <span>{{currentlySelected}} selected</span>
    <button (click)="clearSelection()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
